// extracted by mini-css-extract-plugin
export var container = "_5r-1";
export var editor = "_5r-2";
export var resizable = "_5r-3";
export var wrapper = "_5r-0";